import React, { useState } from 'react';
import PlusSmall from '@uber/base-icons/plus-small';
import Search from '@uber/base-icons/search';
import { styled } from 'baseui';
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import Intent, { type IntentT } from './intent/intent';
const ListContainer = styled('ul', ({
  $theme
}) => ({
  margin: 0,
  padding: 0,
  maxHeight: '500px',
  overflowY: 'scroll'
}));
const IntentContainer = styled('li', ({
  $theme
}) => ({
  margin: 0,
  padding: 0
}));

// @ts-expect-error todo(ts-migration) TS2554 Expected 2 arguments, but got 1.
const AddIntentContainer = styled('div');
type PropsT = {
  intentArr: IntentT[];
  onIntentSelect: (intent: IntentT) => void;
  currentIntent?: IntentT | null;
  addNewIntent?: (intent: string) => void;
};
const IntentList = ({
  intentArr,
  onIntentSelect,
  currentIntent,
  addNewIntent
}: PropsT) => {
  const [searchVal, setSearchVal] = useState('');
  const [newIntentVal, setNewIntentVal] = useState('');
  const [intentError, setIntentError] = useState('');
  const onAddIntent = () => {
    if (addNewIntent) {
      if (!newIntentVal || !newIntentVal.trim()) {
        setIntentError('Invalid Intent: Please enter the intent name');
        setNewIntentVal('');
        return;
      }
      const intentValueToBeAdded = `Other:${newIntentVal}`;
      const isAlreadyPresent = intentArr.find(intent => intent.value.toLowerCase() === intentValueToBeAdded.toLowerCase());
      if (isAlreadyPresent) {
        setIntentError(`Intent: ${intentValueToBeAdded} is already present`);
      } else {
        addNewIntent(intentValueToBeAdded);
        setIntentError('');
        setNewIntentVal('');
      }
    }
  };
  return <div>
      <Input value={searchVal} onChange={e => setSearchVal(e.target.value)} endEnhancer={<Search size="18px" />} placeholder="Search for an intent" clearable overrides={{
      Root: {
        style: () => ({
          borderRadius: '0px'
        })
      }
    }} />
      <ListContainer>
        {intentArr.filter(intent => intent.value.toLowerCase().indexOf(searchVal.toLowerCase()) !== -1).map((intent, index) => <IntentContainer key={index}>
              <Intent intent={intent} onIntentSelect={onIntentSelect} isSelected={currentIntent?.value === intent.value} />
            </IntentContainer>)}
      </ListContainer>
      {addNewIntent && <AddIntentContainer>
          <FormControl error={intentError}>
            <Input value={newIntentVal} onChange={e => setNewIntentVal(e.target.value)} endEnhancer={<PlusSmall onClick={onAddIntent} size={30} />} placeholder="Add an intent" overrides={{
          Root: {
            style: () => ({
              borderRadius: '0px',
              paddingRight: '4px'
            })
          },
          EndEnhancer: {
            style: () => ({
              padding: '0px'
            })
          }
        }} />
          </FormControl>
        </AddIntentContainer>}
    </div>;
};
export default IntentList;
export type { IntentT };